export default __webpack_public_path__ + "static/media/Setting2.d0ea172e.png";